import { Routes } from '@angular/router';
import { DashboardComponent } from './administrativo/dashboard/dashboard.component';
import { SelecaoSistemasComponent } from './cliente/selecao-sistemas/selecao-sistemas.component';
import { CadastroComponent } from './core/componentes/cadastro/cadastro.component';
import { EditarComponent } from './core/componentes/editar/editar.component';
import { IndexComponent } from './core/componentes/index/index.component';
import { LoginComponent } from './core/componentes/login/login.component';
import { Pagina404Component } from './core/componentes/pagina404/pagina404.component';
import { RecuperarSenhaComponent } from './core/componentes/recuperar-senha/recuperar-senha.component';
import { LayoutComponent } from './core/layout/layout/layout.component';
import { ListarPessoaGestao } from './administrativo/gestaoPessoa/listar/listar-pessoas.gestao';
import { ListarSistemasGestao } from './administrativo/gestaoSistema/listar/listar-sistemas.gestao';
import { SistemaGestao } from './administrativo/gestaoSistema/gestao/sistemas.gestao';
import { ListarPlanosGestao } from './administrativo/gestaoPlano/listar/listar-planos.gestao';
import { PlanoGestao } from './administrativo/gestaoPlano/gestao/plano.gestao';
import { PessoaGestao } from './administrativo/gestaoPessoa/gestao/pessoa.gestao';

export const routes: Routes = [
  { path: '', component: IndexComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: LayoutComponent,
    children: [{ path: '', component: DashboardComponent }],
  },
  {
    path: 'pessoa',
    component: LayoutComponent,
    children: [{ path: ':id', component: PessoaGestao },
      { path: '', component: Pagina404Component }
    ],
  },
  {
    path: 'listar-pessoas',
    component: LayoutComponent,
    children: [{ path: '', component: ListarPessoaGestao }],
  },
  {
    path: 'sistema',
    component: LayoutComponent,
    children: [{ path: ':id', component: SistemaGestao },
      { path: '', component: Pagina404Component }
    ],
  },
  {
    path: 'listar-sistemas',
    component: LayoutComponent,
    children: [{ path: '', component: ListarSistemasGestao }],
  },
  {
    path: 'listar-planos',
    component: LayoutComponent,
    children: [{ path: '', component: ListarPlanosGestao }],
  },
  {
    path: 'plano',
    component: LayoutComponent,
    children: [{ path: ':id', component: PlanoGestao },
      { path: '', component: Pagina404Component }
    ],
  },
  {
    path: 'cadastro',
    component: CadastroComponent,
  },
  {
    path: 'editar',
    component: EditarComponent,
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
  },
  {
    path: 'selecao-sistemas',
    component: SelecaoSistemasComponent,
  },
  {
    path: '**',
    component: Pagina404Component,
  },
];
